import { Wrench } from "lucide-react";
import { useT, useTRaw } from "@/context/ContentContext";

const DEFAULT_LIST = [
    "Demolições", "Alvenarias", "Rebocos e Estuques", "Gesso Cartonado / Pladur",
    "Pinturas", "Pavimentos", "Revestimentos", "Impermeabilizações",
    "Isolamentos Térmicos e Acústicos", "Canalização", "Eletricidade",
    "Climatização e Ar Condicionado", "Ventilação", "Carpintaria", "Serralharia",
    "Caixilharia", "Vidros", "Estores", "Coberturas e Telhados", "Fachadas",
    "Cozinhas", "Casas de Banho", "Microcimento e Revestimentos Contínuos",
];

export default function HomeEspecialidades() {
    const t = useT();
    const tRaw = useTRaw();
    const listRaw = tRaw("home.esp.list", DEFAULT_LIST.join("\n"));
    const list = listRaw.split(/\r?\n/).map(s => s.trim()).filter(Boolean);
    return (
        <section className="py-16 sm:py-24">
            <div className="max-w-6xl mx-auto px-6 sm:px-10">
                <div className="eyebrow mb-6"><Wrench className="w-3.5 h-3.5" /> {t("home.esp.eyebrow", "Especialidades")}</div>
                <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-[1.05] max-w-3xl">
                    {t("home.esp.title", "Uma obra.")} <span className="font-serif-italic text-[hsl(var(--copper))]">{t("home.esp.title_accent", "Todas as especialidades")}</span><span className="text-[hsl(var(--copper))]">.</span>
                </h2>
                <p className="text-[hsl(var(--graphite))]/70 text-lg mt-6 max-w-2xl">
                    {t("home.esp.subtitle", "Uma remodelação raramente envolve apenas uma especialidade. Asseguramos e coordenamos os diferentes trabalhos necessários para que não tenha de gerir vários profissionais separadamente.")}
                </p>
                <div className="flex flex-wrap gap-2 mt-10">
                    {list.map((e, i) => (
                        <span key={`${e}-${i}`} className="px-4 py-2 bg-white rounded-full text-sm font-medium !text-[hsl(var(--forest))] border border-[hsl(var(--forest))]/25 hover:bg-[hsl(var(--forest))] hover:!text-white transition cursor-default">{e}</span>
                    ))}
                </div>
            </div>
        </section>
    );
}
